import Axios from 'axios'
import type { AxiosRequestHeaders } from 'axios'

export const HttpService = Axios.create({ baseURL: '' })

export const createHttpService = (baseURL: string, headers?: AxiosRequestHeaders) => {
  return Axios.create({ baseURL, headers })
}
